<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="formData.return_sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>

    <el-card shadow="never" class="info-card">
      <el-row>
        <el-col :span="2" class="item-text">回料申请编号：</el-col>
        <el-col :span="6" class="item-value">{{ info.request_id }}</el-col>
        <el-col :span="2" class="item-text">申请状态：</el-col>
        <el-col :span="6" class="item-value">{{ info.status_name }}</el-col>
        <el-col :span="2" class="item-text">申请时间：</el-col>
        <el-col :span="6" class="item-value">{{ info.create_time }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">申请人：</el-col>
        <el-col :span="6" class="item-value">{{ info.create_user_name }}</el-col>
        <el-col :span="2" class="item-text">申请备注：</el-col>
        <el-col :span="6" class="item-value">{{ info.remark }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">物料编码：</el-col>
        <el-col :span="6" class="item-value">{{ info.material_code }}</el-col>
        <el-col :span="2" class="item-text">物料名称：</el-col>
        <el-col :span="6" class="item-value">{{ info.material_name }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="item-text">回料个人库：</el-col>
        <el-col :span="6" class="item-value">{{ info.from_store_name }}</el-col>
        <el-col :span="2" class="item-text">目标总库：</el-col>
        <el-col :span="6" class="item-value">{{ info.to_store_name }}</el-col>

      </el-row>
    </el-card>

    <div style="margin: 20px 0 0 8px">
      <el-form label-width="130px">
        <el-form-item label="退入库位：">
          <el-select v-model="formData.location_id" class="input" placeholder="退入库位" clearable>
            <el-option v-for="location in info.location_list" :key="location.id" :label="location.code" :value="location.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核备注：">
          <el-input type="textarea" class="input" v-model="formData.approval_remark" placeholder="审核备注" :autosize="true"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="agreeRequest" :loading="loading">接收回料</el-button>
          <el-button @click="rejectRequest" :loading="loading">否决申请</el-button>
          <KfMessage ref="commitMessage"/>
        </el-form-item>
      </el-form>

    </div>

  </div>
</template>

<script>
export default {
  name: "ApprovalReturnRequestBySn",
  data() {
    return {
      formData: {
        id: '',
        return_sn: '',
        location_id: '',
        approval_remark: ''
      },
      loading: false,
      info: {}
    }
  },
  methods: {
    search() {
      this.$refs.searchMessage.clear()
      this.$refs.commitMessage.clear()

      this.info = {}
      if (!this.formData.return_sn) {
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('wmsReturnRequestService.getReturnRequestInfoBySn', {
        return_sn: this.formData.return_sn
      }, false).then(data => {
        this.loading = false
        this.info = data || {}

        this.formData.location_id = this.info.location_id

        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })

    },
    agreeRequest() {
      this.$refs.searchMessage.clear()
      this.$refs.commitMessage.clear()

      if (!this.info.id) {
        return this.$refs.commitMessage.showError('请先扫SN进行查询')
      }

      this.formData.id = this.info.id

      let sn = this.formData.return_sn

      this.loading = true;
      this.$http('wmsReturnRequestService.agreeBySn', this.formData, false).then(data => {
        this.loading = false

        this.info = {}
        this.formData = {}

        return this.$refs.commitMessage.showSuccess(`【${sn}】提交成功`);
      }, errMsg => {
        this.loading = false
        return this.$refs.commitMessage.showError(errMsg)
      })
    },
    rejectRequest() {
      this.$refs.searchMessage.clear()
      this.$refs.commitMessage.clear()

      if (!this.info.request_id) {
        return this.$refs.commitMessage.showError('请先扫SN进行查询')
      }

      let sn = this.formData.return_sn

      this.loading = true;
      this.$http('wmsReturnRequestService.reject', {
        id: this.info.request_id
      }, false).then(data => {
        this.loading = false

        this.info = {}
        this.formData.location_id = ''
        this.formData.return_sn = ''
        this.formData.id = ''

        return this.$refs.commitMessage.showSuccess(`【${sn}】提交成功`);
      }, errMsg => {
        this.loading = false
        return this.$refs.commitMessage.showError(errMsg)
      })


    }
  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}


.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
  line-height: 32px;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

</style>